// import React from "react";

import AwsConfig from '../../Config/AwsConfig'

export default function PosterCdnCheck(url) {
  // const poster = url => {
  if (url) {
    const cdnurl = AwsConfig.movieCdnUrl
    if (url && !url.includes(cdnurl)) {
      url = cdnurl + url
      return url
    }

    return url
  }
}
// return <div>PosterCdnCheck</div>;
// }
//
